'use client';

import { c as _c } from "react/compiler-runtime";
import { useConsentGatedInit } from '../hooks';
type BrandContentV2Props = {
  initializeWebcollage: () => void;
};
export const BrandContentV2 = t0 => {
  const $ = _c(2);
  const {
    initializeWebcollage
  } = t0;
  let t1;
  if ($[0] !== initializeWebcollage) {
    t1 = {
      src: "//scontent.webcollage.net/api/v2/product-content",
      consentGroup: "C0003",
      onReady: initializeWebcollage
    };
    $[0] = initializeWebcollage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useConsentGatedInit(t1);
  return null;
};